/* ml-meet.js
   Booking links open in a dialog instead of leaving the page.

   Why a delegated listener rather than editing the links: the booking
   destination appears in roughly forty JSON templates, in hero CTAs,
   tier cards, split rows, slide buttons and stock image-with-text
   blocks, under a dozen different labels. Matching on the destination
   catches all of them, catches the ones nobody remembers, and catches
   the ones added next month, with nothing to keep in sync.

   Matching is on the host, not on the label. Anything served from
   meetings.hubspot.com or meetings-na2.hubspot.com is a scheduler, so
   it belongs in the dialog whether the button says "Book A Meeting",
   "Request a demo" or "Talk to us".

   Deliberately left alone:
   - modified clicks (ctrl, cmd, shift, alt) and middle clicks, so
     "open in a new tab" still means that
   - anything inside the store request wizard, which has had its own
     booking modal since before this existed
   - any link carrying data-ml-meet="off"
   - a click another handler has already claimed */
(function () {
  if (window.mlMeetReady) return;
  window.mlMeetReady = true;

  var HOSTS = /^meetings(-[a-z0-9]+)?\.hubspot\.com$/i;

  var dlg = null;
  var frame = null;
  var foot = null;
  var loaded = '';

  function el() {
    if (dlg) return dlg;
    dlg = document.querySelector('[data-ml-meet-dialog]');
    if (!dlg) return null;
    frame = dlg.querySelector('.ml-meet__frame');
    foot = dlg.querySelector('[data-ml-meet-fallback]');

    var x = dlg.querySelector('.ml-meet__x');
    if (x) x.addEventListener('click', close);

    /* A click on the backdrop lands on the dialog element itself,
       because the dialog's own content sits in a child wrapper. */
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) close();
    });

    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('ml-meet-open');
    });

    if (frame) {
      frame.addEventListener('load', function () {
        dlg.classList.add('is-ready');
      });
    }
    return dlg;
  }

  /* HubSpot's scheduler needs embed=true to render without its own
     page chrome. Everything already on the URL is preserved, so a
     calendar with tracking parameters keeps them. */
  function embedUrl(href) {
    var u;
    try {
      u = new URL(href, window.location.href);
    } catch (err) {
      return null;
    }
    if (!HOSTS.test(u.hostname)) return null;
    u.searchParams.set('embed', 'true');
    return u;
  }

  function open(u) {
    var d = el();
    if (!d) return false;

    if (loaded !== u.href) {
      d.classList.remove('is-ready');
      if (frame) {
        frame.setAttribute('title', 'Booking calendar');
        frame.src = u.href;
      }
      loaded = u.href;
    }

    if (foot) {
      /* Without embed=true, so the fallback link opens the normal
         scheduler page rather than a bare embed. */
      var plain = new URL(u.href);
      plain.searchParams.delete('embed');
      foot.href = plain.href;
    }

    if (typeof d.showModal !== 'function') return false;
    document.documentElement.classList.add('ml-meet-open');
    d.showModal();
    return true;
  }

  function close() {
    if (dlg && dlg.open) dlg.close();
    document.documentElement.classList.remove('ml-meet-open');
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    if (e.button && e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (window.mlMeetDisabled) return;

    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    if (a.getAttribute('data-ml-meet') === 'off') return;
    if (a.closest('[class*="mlsr"]')) return;

    var u = embedUrl(a.getAttribute('href'));
    if (!u) return;

    if (open(u)) e.preventDefault();
  });
})();
